import { connect } from "react-redux";
import SalesforceAddressSetting from "../components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceAddressSetting";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";
import { SalesforceSettingDirectory } from "../constants/ComponentTypes";
import { initializeMessage } from '../redux/actions/Common';
import { jobCompleted } from "../redux/actions/Broadcasting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  tab: SalesforceSettingDirectory.ADDRESS_BOOK.value,
  sobject_name: state.sfdcAddressSetting.sobject_name,
  listview_id: state.sfdcAddressSetting.listview_id,
  listviews: state.sfdcAddressSetting.listviews,
  isLoadingMapping: state.sfdcAddressSetting.isLoadingMapping,
  isLoadingPreview: state.sfdcAddressSetting.isLoadingPreview,
  fields: state.sfdcAddressSetting.fields,
  preview: state.sfdcAddressSetting.preview,
  mapping: state.sfdcAddressSetting.mapping,
  errorMessage: state.sfdcAddressSetting.errorMessage,
  shortMessage: state.sfdcAddressSetting.shortMessage,
  successMessage: state.sfdcAddressSetting.successMessage || state.broadcasting.jobSuccessMessage,
  loadingPreviewFailed: state.sfdcAddressSetting.loadingPreviewFailed,
  expiredAccessError: state.sfdcAddressSetting.expiredAccessError,
  isConfiguring: state.salesforce.isConfiguring,
  isJobCompletedLoading: state.broadcasting.isJobCompletedLoading,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceImportMappings() {
    dispatch(actions.getSalesforceImportMappings());
  },

  getSalesforcePreview(sobject_name, data) {
    dispatch(actions.getSalesforcePreview(sobject_name, data));
  },

  configAndSync(data) {
    dispatch(actions.configAndSync(data));
  },

  postSalesforceConfig(data) {
    dispatch(actions.postSalesforceConfig(data));
  },

  postSalesforceSync() {
    dispatch(actions.postSalesforceSync());
  },

  initializeMessage() {
    dispatch(initializeMessage());
  },

  jobCompleted(userId) {
    dispatch(jobCompleted(userId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceAddressSetting);



// WEBPACK FOOTER //
// ./src/containers/SalesforceAddressSetting.js